export const TOGGLE_INSTRUCTION = 'TOGGLE_INSTRUCTION';

function S4() {
  const crypto = window.crypto || window.msCrypto;
  const randomArray = new Uint32Array(1);
  crypto.getRandomValues(randomArray);
  return (((1 + randomArray[0]) * 0x10000) || 0).toString(16).substring(1);
}

function toggle() {
  return {
    type: TOGGLE_INSTRUCTION,
    instructionToggled: `${ S4() }${ S4() }-${ S4() }-4${ S4().substring(0, 3) }-${ S4() }-${ S4() }${ S4() }${ S4() }`.toLowerCase()
  };
}

export function toggleInstruction() {
  return (dispatch) => {
    dispatch(toggle());
  };
}
